module.exports = __webpack_public_path__ + "img/icon_sm_hdqs.fa5ed014.png";